// extracted by mini-css-extract-plugin
module.exports = {"componentsSelectPaymentMethod":"styles_componentsSelectPaymentMethod__6AOLt","opText":"styles_opText__2bwhr"};